<template>
  <div class="container my-0 my-lg-5">
    <!--Section: Content-->
    <section class="article-section">
      <!-- Grid row -->
      <div class="row">
        <!-- Grid column -->
        <div
          class="card-group col-lg-4 col-12 mb-lg-0 mb-4"
          v-for="post in posts"
          :key="post.id"
        >
          <!-- Card -->
          <div class="card hoverable m-4" @click="showPost(post.id)">
            <!-- Card image -->
            <div class="card-title d-flex justify-content-center">
              <p>{{ post.title }}</p>
            </div>
            <img
              class="card-img-top"
              :src="'https://api-blog.livratos.fr' + post.img.contentUrl"
              alt="photo-article"
            />
            <!-- Card content -->
            <div class="card-body">
              <!-- Title -->
              <div class="label-card">
                <p>Catégorie,</p>
                <p>tags:</p>

                <!--<div>
                  <div v-if="post.updatedAt !== '' && post.updatedAt !== null">
                    <p>modifié le:</p>
                  </div>
                  <div v-else>
                    <p>publié le:</p>
                  </div>
                </div>-->
              </div>
              <div class="card-body__header">
                <div>
                  <p class="card-category text-uppercase font-small">
                    {{ post.category.name }}
                  </p>
                </div>
                <div class="tags">
                  <div class="tag" v-for="tag in post.tags" :key="tag.id">
                    <strong>{{ tag.label }}</strong>
                  </div>
                </div>
              </div>
            </div>

            <!-- Card -->
          </div>
          <!-- Grid column -->
        </div>
        <!-- Grid row -->
      </div>
    </section>
    <!--Section: Content-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { formatDate } from "@/assets/globalJs/global.js";
export default {
  name: "AuthorArticleSelect",
  props: {
    posts: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formattedDate() {
      return formatDate(this.post.updatedAt);
    },
    ...mapGetters({
      Posts: "StatePosts",
      User: "StateUser",
      Post: "StatePost",
      Hydraview: "StateHydraview",
    }),
  },
  methods: {
    ...mapActions(["GetPosts", "GetPost"]),
    async showPost(id) {
      try {
        await this.GetPost(id);
        this.$router.push({
          name: "edit",
          params: { slug: this.Post.slug },
        });
        this.showError = false;
      } catch (error) {
        this.showError = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.article-section {
  margin-bottom: 200px;
  width: 100%;
  height: 500px;
  overflow-y: scroll;
  border-bottom: 1px solid $color-primary;
}
.label-card {
  font-size: 0.6em;
  display: flex;
  justify-content: space-between;
  color: whitesmoke;
  @media screen and (min-width: 992px) {
    color: $color-text-grey;
  }
}
p {
  margin-bottom: 0.3px;
}
.card {
  border-radius: 10px 10px 2px 2px;
  @include hover-effect-grown;
  transition: 0.5s;
  cursor: pointer;
  background-color: $color-darker;
  @media screen and (min-width: 992px) {
    background-color: $background;
  }
  .card-title {
    background-color: $color-darker;
    color: $color-primary;
    @media screen and (min-width: 992px) {
      background-color: #fafafa;
      color: $color-darker;
    }
    font-size: 0.9em;
    padding: 5px 10px;
    margin: 0px;
    text-align: center;
    border-radius: 10px 10px 2px 2px;
  }
  .card-img-top {
    height: 200px;
    object-fit: cover;
    display: block;
    margin: 0 auto;
  }
  .card-body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    background-color: $color-darker;
    border-top: 0.5px $color-primary outset;
    color: $color-text;
    @media screen and (min-width: 992px) {
      background-color: $color-lighter;
      border: none;
    }
    padding: 10px;
    &__header {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-start;
      flex-wrap: wrap;
      margin-bottom: 0.5px;
      .card-category {
        width: fit-content;
        font-size: 0.7em;
        margin-top: 3px;
        margin-right: 4px;
        margin-bottom: 5px;
        padding: 0.5px 5px;
        border: 0.5px $color-primary outset;
        border-radius: 3px 9px;
        color: $color-primary;
        @media screen and (min-width: 992px) {
          background-color: $color-primary;
          color: $color-darker;
        }
      }
      .card-date {
        font-size: 0.5em;
        @media screen and (max-width: 992px) {
          @include text-gradient(#f1eeee, #f27316);
        }
        @media screen and (min-width: 992px) {
          color: $color-text-grey;
        }
      }
    }
    .tags {
      font-size: 0.6em;
      display: flex;
      margin-top: 3px;
      .tag {
        display: block;
        margin-right: 4px;
        padding: 0.5px 4px;
        border: 0.5px $color-primary outset;
        border-radius: 9px 3px;
        background-color: $color-lighter;
        color: $color-darker;
        @media screen and (min-width: 992px) {
          color: $color-text-grey;
        }
      }
    }
  }
  &:hover {
    background-color: $color-darker;
    .label-card {
      color: whitesmoke;
    }
    .card-body {
      background-color: $color-darker;
      border-top: 1px $color-primary solid;
    }
    .card-category {
      border: 0.5px $color-primary outset;
      background-color: $color-darker;
      color: white;
    }
    .tag strong {
      background-color: $color-lighter;
      color: $color-darker;
    }
    .card-title,
    .card-date {
      @include text-gradient(#86cb28, #86cb28);
    }
    .card-title {
      & p {
        text-shadow: none;
      }
    }
  }
}
a.page-link {
  color: $color-darker;
}
/* Style pour les éléments désactivés */
ul.pagination li.page-item.disabled a.page-link {
  color: #999 !important;
  pointer-events: none;
  cursor: not-allowed;
}

/* Style pour les éléments actifs */
ul.pagination li.page-item.active a.page-link {
  background-color: $color-darker;
  color: $color-primary;
  border-color: $color-primary;
}
</style>
